import React from "react";
import LearningStatistics from "../../components/LearningStatistics";

const Statistics: React.FunctionComponent = () => {
  return <LearningStatistics />;
};

export default Statistics;
